import { SSO_PROVIDER_NAME_REGEX } from '@common/neo.tax';
import { useSearchParams } from 'react-router-dom';

import { env, LocalStorageKey } from '@neo.tax/shared';

interface UseDefaultSsoProviderIdResult {
  defaultSsoProviderId: string;
}

export const useDefaultSsoProviderId = (): UseDefaultSsoProviderIdResult => {
  const [searchParams, setSearchParams] = useSearchParams();

  const ssoProviderIdFromParams = searchParams.get('ssoProviderId');
  const isSsoProviderFromParamsValid = !!(
    ssoProviderIdFromParams && ssoProviderIdFromParams.match(SSO_PROVIDER_NAME_REGEX)
  );

  // if the query params are not valid, remove them
  if (!isSsoProviderFromParamsValid && ssoProviderIdFromParams) {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete('ssoProviderId');
    newSearchParams.delete('continue');
    setSearchParams(newSearchParams);
  }

  const defaultSsoProviderId = isSsoProviderFromParamsValid
    ? ssoProviderIdFromParams
    : env.REACT_APP_ENTERPRISE_SSO_DEFAULT_PROVIDER_ID ||
      localStorage.getItem(LocalStorageKey.PERSIST_ENTERPRISE_SSO_PROVIDER_ID) ||
      '';

  return {
    defaultSsoProviderId,
  };
};
